export const DEFAULT_COLORS = {
  rollingOffer: {
    background: { colorOne: '#272727' },
    subBackground: { colorOne: '#ffffff' },
    lockImage: 'https://media.appcharge.com/defaults/lock_icon.png'
  },
  progressBar: {
    barFill: {
      colorOne: '#FFD450',
      colorTwo: '#EDB923',
      gradientDirection: 'to bottom'
    },
    accumulatedItem: {
      backgroundColor: {
        colorOne: '#F28CFE',
        colorTwo: '#9539FB',
        gradientDirection: 'to bottom'
      }
    },
    background: {
      colorOne: '#DABA98',
      colorTwo: '#FDFCF9',
      gradientDirection: 'to right'
    },
    border: {
      colorOne: '#DBBD9C',
      colorTwo: '#DBBD9C',
      gradientDirection: 'to right'
    },
    textColor: '#FFFFFF'
  },
  specialOffer: {
    mainColor: { colorOne: '#ffffff' },
    background: { colorOne: '#CACBD4' }
  }
};

export const DEFAULT_NUMBERS = {
  opacity: 80,
  borderWidth: 3,
  radius: 12,
  fontSize: 20,
  subFontSize: 16
};

export const DEFAULT_TEXT = {
  collect: 'Collect',
  free: 'FREE',
  normal: 'normal',
  single: 'Single'
};
